var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_4930)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_175_4930)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55311 -0.727295H0V2.1818L21.433 16.7273L24 16.7273V13.8182L2.55311 -0.727295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.851541 -0.727295L24 15.023V16.7273H23.1684L0 0.960628V-0.727295H0.851541Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7143 -0.727295H24V2.1818C24 2.1818 9.15406 11.8726 2.28571 16.7273H0V13.8182L21.7143 -0.727295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 -0.727295H23.2249L0 15.0366V16.7273H0.851541L24 0.973375V-0.727295Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72809 -0.727295H15.2919V4.65664H24V11.3398H15.2919V16.7273H8.72809V11.3398H0V4.65664H8.72809V-0.727295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1053 -0.727295H13.8947V5.98599H24V10.014H13.8947V16.7273H10.1053V10.014H0V5.98599H10.1053V-0.727295Z",
    fill: "#F93939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_175_4930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.e6d54935d7a20f0b6c83bcac16923385.svg";
export { ForwardRef as ReactComponent };